import { titleCase } from 'change-case'
import { MouseEventHandler } from 'react'
import { ToastOptions } from 'react-toastify'
import { pluralize } from '@opallabs/lambda'
import { ActionToast, type ToastComponent } from '@opallabs/lapidary'

export const defaultAddToBoardFailureOptions: ToastOptions = {
  toastId: 'add-to-board-failure',
  type: 'error',
  closeOnClick: true,
  autoClose: false,
}

type FailedToastProps = {
  errorMessage?: string
  momentCount: number
  resourceDisplayName?: string
  onActionClick?: MouseEventHandler<HTMLButtonElement>
}

export const AddToBoardDuplicateFailureToast: ToastComponent<
  FailedToastProps
> = ({
  momentCount,
  onActionClick,
  resourceDisplayName = 'moment',
  ...toastProps
}) => {
  return (
    <ActionToast
      {...toastProps}
      actionText="Show Failed Items"
      onActionClick={onActionClick}
      message={
        <>
          {`${momentCount} ${pluralize(resourceDisplayName, momentCount)} could
          not be added to one or more boards because ${momentCount > 1 ? 'they are' : 'it is'}
          already paired with that board`}
        </>
      }
      title={`${pluralize(titleCase(resourceDisplayName), momentCount)} ${momentCount > 1 ? "weren't" : "wasn't"} added to board`}
    />
  )
}

export const AddToBoardFailureToast: ToastComponent<FailedToastProps> = ({
  errorMessage = '',
  momentCount,
  onActionClick,
  resourceDisplayName = 'moment',
  ...toastProps
}) => {
  return (
    <ActionToast
      {...toastProps}
      actionText="Show Failed Items"
      onActionClick={onActionClick}
      message={
        <>
          {`${momentCount} ${pluralize(resourceDisplayName, momentCount)} failed to be added to one or more boards. ${errorMessage}`}
        </>
      }
      title={`${pluralize(titleCase(resourceDisplayName), momentCount)} ${momentCount > 1 ? "weren't" : "wasn't"} added to board`}
    />
  )
}
